<!-- 
    导入标签
    jay 2020-02-28
 -->
<template>
  <div class="childRoute-wrapper">
    <van-nav-bar
      :title="$t('recharge.labelManagement')"
      :fixed="true"
      left-arrow
      @click-left="navbarback"
    >
    </van-nav-bar>
    <div class="scroll-wrapper" :class="{ noCrad: !tagList.length }">
      <van-cell-group :border="false" class="tag-list" v-if="tagList.length">
        <van-cell
          :border="false"
          :title="item.tag_name"
          v-for="(item, index) in tagList"
          :key="index"
        >
          <div class="tag-handle" slot="default">
            <a @click="editFun(index)">{{ $t("common.edit") }}</a>
            <a @click="delTags(index)">{{ $t("common.delete") }}</a>
          </div>
        </van-cell>
      </van-cell-group>
      <div v-else class="noCard-wrap">
        <img src="@/assets/images/public/pic_kong@2x.png" />
        <p class="text-gray">{{ $t("common.noData") }}</p>
      </div>
    </div>

    <van-dialog
      v-model="editFlag"
      :title="$t('recharge.editLabel')"
      :confirmButtonText="$t('common.save')"
      show-cancel-button
      :beforeClose="userMobileTagsEdit"
    >
      <van-cell-group :border="false" class="tag-input">
        <van-field
          :border="false"
          v-model="tagName"
          :placeholder="$t('recharge.enterLabelName')"
        />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    },
    tagManageFlag: {
      //显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  components: {},
  data() {
    return {
      editFlag: false, //编辑
      tagName: "", //输入框的标签名
      tagIndex: -1 //当前编辑的下标
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navbarback() {
      //返回上一页
      this.$emit("update:tagManageFlag", false);
    },
    editFun(index) {
      //编辑标签弹窗
      let vm = this;
      vm.editFlag = true;
      vm.tagName = vm.tagList[index].tag_name;
      vm.tagIndex = index;
    },
    userMobileTagsEdit(action, done) {
      let vm = this;
      if (action === "confirm") {
        //编辑标签确认
        if (vm.tagName == "") {
          vm.$toast(vm.$t("recharge.enterLabelName"));
          //弹窗不关闭
          done(false);
          return false;
        }

        let reg = /^[\da-z\u4e00-\u9fa5]{2,4}$/i;
        if (!reg.test(vm.tagName)) {
          vm.$toast(vm.$t("recharge.enter2-4letterOrChinese"));
          //弹窗不关闭
          done(false);
          return false;
        }
        let params = {};
        params.tag_id = vm.tagList[vm.tagIndex].id;
        params.tag_name = vm.tagName;
        vm.$post("/app/user/userMobileTagsEdit", params, {
          alert: true
        }).then(res => {
          console.log("userMobileTagsEdit", res);
          vm.$toast(res.msg);
          if (res.code == 0) {
            let data = {};
            data.type = 1;
            data.index = vm.tagIndex;
            data.tagName = vm.tagName;
            vm.$emit("changeTagList", data);
            //弹窗关闭
            done();
          } else {
            //弹窗不关闭
            done(false);
          }
        });
      } else {
        //点击取消 弹窗关闭
        done();
      }
    },
    delTags(index) {
      //删除标签
      let vm = this;
      vm.$dialog
        .confirm({
          message: vm.$t("recharge.sureLabelAndPhone"),
          beforeClose(action, done) {
            if (action === "confirm") {
              let params = {};
              params.tag = vm.tagList[index].id;
              vm.$post("/app/user/delTags", params, { alert: true }).then(
                res => {
                  console.log("delTags", res);
                  vm.$toast(res.msg);
                  if (res.code == 0) {
                    let data = {};
                    data.type = 2;
                    data.index = index;
                    vm.$emit("changeTagList", data);
                    //弹窗关闭
                    done();
                  } else {
                    //弹窗不关闭
                    done(false);
                  }
                }
              );
            } else {
              done();
            }
          }
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.tag-list {
  .van-cell {
    padding: 0;
    height: 54px;
    padding: 0 22px;
    align-items: center;
    border-bottom: 1.1px solid #e4e4e4;
    .van-cell__title {
      font-size: 16px;
    }
    .tag-handle {
      a {
        color: #2042ab;
        font-size: 14px;
      }
      a + a {
        margin-left: 16px;
      }
    }
  }
}
.tag-input {
  padding: 22px;
  /deep/.van-cell {
    padding: 0 12px;
    height: 30px;
    background: #f0f2f5;
    border-radius: 3px;
    font-size: 16px;
    .van-field__body,
    .van-field__control {
      height: 100%;
    }
  }
}
</style>
